/** Analytics bucket helpers — aligned with backend `categorize_scan_path` / `ADMIN_SEARCH_PATHS`. */

const VALID_BUCKETS = new Set(['name', 'email', 'phone', 'due_diligence', 'ai_preprocess', 'other']);

/** Map API paths to analytics buckets (must align with backend `_SEARCH_PATHS`). */
export function categorizeScanPath(path) {
  const p = String(path || '').toLowerCase();
  if (!p) return 'other';
  if (p.includes('aggregate-email-stream')) return 'email';
  if (p.includes('aggregate-phone-stream')) return 'phone';
  if (p.includes('aggregate-company-stream') || p.includes('aggregate-corporate-stream')) return 'due_diligence';
  if (p.includes('search/preprocess')) return 'ai_preprocess';
  if (p.includes('aggregate-stream-name')) return 'name';
  return 'other';
}

function pathFromSearchItem(it) {
  let path = it?.path || '';
  if (!path && it?.full_url && typeof it.full_url === 'string') {
    try {
      path = new URL(it.full_url, 'https://placeholder.local').pathname;
    } catch {
      path = '';
    }
  }
  return path;
}

/** Resolve bucket from API item (`bucket` field preferred, else path heuristic). */
export function resolveSearchBucket(it) {
  const bucket = String(it?.bucket || '').trim();
  if (VALID_BUCKETS.has(bucket)) return bucket;
  return categorizeScanPath(pathFromSearchItem(it));
}

/**
 * Count feature requests from unified `GET /admin/last-searches` items only.
 * Does not merge traffic-log lines (avoids double-counting SSE requests).
 */
export function buildFeatureRequestCounts(searches) {
  const out = { name: 0, email: 0, phone: 0, due_diligence: 0, ai_preprocess: 0, other: 0 };
  for (const it of searches || []) {
    const k = resolveSearchBucket(it);
    if (Object.prototype.hasOwnProperty.call(out, k)) out[k] += 1;
  }
  return out;
}
